document.addEventListener('DOMContentLoaded', function () {
    // =======================
    // AREA FILTER - Update dropdown text on selection
    // =======================
    const areaFilter = document.getElementById('areaFilter');

    if (areaFilter) {
        const dropdownToggle = areaFilter.querySelector('.dropdown-toggle');
        const dropdownItems = areaFilter.querySelectorAll('.dropdown-item');
        const defaultText = dropdownToggle ? dropdownToggle.textContent.trim() : 'Area';

        dropdownItems.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();

                // Get only the text from the span, not the icon
                const textSpan = this.querySelector('span:not(.material-symbols-outlined)');
                const textContent = textSpan ? textSpan.textContent.trim() : this.textContent.trim();

                // Update the dropdown toggle text (preserving the arrow that will be added by arrows.js)
                if (dropdownToggle) {
                    // Remove the arrow temporarily if it exists
                    const arrow = dropdownToggle.querySelector('.arrow');
                    if (arrow) {
                        arrow.remove();
                    }

                    // Update text
                    dropdownToggle.textContent = textContent;

                    // Add or remove 'selected' class based on whether a selection is active
                    if (textContent !== defaultText) {
                        dropdownToggle.classList.add('selected');
                    } else {
                        dropdownToggle.classList.remove('selected');
                    }

                    // Re-add the arrow
                    dropdownToggle.insertAdjacentHTML('beforeend', "<div class='arrow arrow--smallest arrow--down arrow--white ms-1'><span></span><span></span></div>");
                }
            });
        });
    }

    // =======================
    // CATEGORY FILTER - Accordion with radio and checkboxes
    // =======================
    const categoryFilter = document.getElementById('categoryFilter');

    if (categoryFilter) {
        const categoryToggle = categoryFilter.querySelector('.dropdown-toggle');
        const categoryRadios = categoryFilter.querySelectorAll('.category-radio');
        const typeCheckboxes = categoryFilter.querySelectorAll('.type-checkbox');
        const categoryApplyBtn = document.getElementById('categoryApplyBtn');
        const dropdownMenu = categoryFilter.querySelector('.dropdown-menu');

        // Close dropdown when clicking "Vedi i risultati"
        if (categoryApplyBtn) {
            categoryApplyBtn.addEventListener('click', function () {
                // Close the dropdown manually by removing Bootstrap classes
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('show');
                }
                if (categoryToggle) {
                    categoryToggle.classList.remove('show');
                    categoryToggle.setAttribute('aria-expanded', 'false');

                    // Remove active class from arrow
                    const arrow = categoryToggle.querySelector('.arrow');
                    if (arrow) {
                        arrow.classList.remove('active');
                    }
                }
            });
        }

        // Handle radio selection
        categoryRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                if (this.checked) {
                    const selectedCategory = this.value;

                    // Uncheck all checkboxes from other categories
                    typeCheckboxes.forEach(function (checkbox) {
                        if (checkbox.dataset.category !== selectedCategory) {
                            checkbox.checked = false;
                        }
                    });

                    // Check "Vedi tutte" for the selected category
                    const allTypesCheckbox = categoryFilter.querySelector('.all-types[data-category="' + selectedCategory + '"]');
                    if (allTypesCheckbox) {
                        allTypesCheckbox.checked = true;
                    }

                    updateCategoryToggleText();
                }
            });
        });

        // Handle checkbox selection
        typeCheckboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                const category = this.dataset.category;
                const isAllTypes = this.classList.contains('all-types');
                const otherCheckboxes = categoryFilter.querySelectorAll('.type-checkbox[data-category="' + category + '"]:not(.all-types)');
                const allTypesCheckbox = categoryFilter.querySelector('.all-types[data-category="' + category + '"]');

                if (isAllTypes && this.checked) {
                    // If "Vedi tutte" is checked, uncheck all other types
                    otherCheckboxes.forEach(function (cb) {
                        cb.checked = false;
                    });
                } else if (!isAllTypes && this.checked) {
                    // If a specific type is checked, uncheck "Vedi tutte"
                    if (allTypesCheckbox) {
                        allTypesCheckbox.checked = false;
                    }
                }

                // If no checkbox is selected, check "Vedi tutte"
                const anyChecked = Array.from(categoryFilter.querySelectorAll('.type-checkbox[data-category="' + category + '"]')).some(function (cb) {
                    return cb.checked;
                });

                if (!anyChecked && allTypesCheckbox) {
                    allTypesCheckbox.checked = true;
                }

                updateCategoryToggleText();
            });
        });

        function updateCategoryToggleText() {
            const selectedRadio = categoryFilter.querySelector('.category-radio:checked');

            if (!selectedRadio) {
                setCategoryToggleText('Categorie');
                return;
            }

            const category = selectedRadio.value;
            const selectedCheckboxes = Array.from(categoryFilter.querySelectorAll('.type-checkbox[data-category="' + category + '"]:checked'));

            // If "Vedi tutte" is selected
            const allTypesChecked = selectedCheckboxes.some(function (cb) {
                return cb.classList.contains('all-types');
            });

            if (allTypesChecked) {
                setCategoryToggleText(category);
                return;
            }

            // Get selected types (excluding "Vedi tutte")
            const selectedTypes = selectedCheckboxes.filter(function (cb) {
                return !cb.classList.contains('all-types');
            });

            if (selectedTypes.length === 0) {
                setCategoryToggleText('Categorie');
            } else if (selectedTypes.length === 1) {
                setCategoryToggleText(selectedTypes[0].value);
            } else {
                // Multiple selections: show first + count
                const firstType = selectedTypes[0].value;
                const additionalCount = selectedTypes.length - 1;
                setCategoryToggleText(firstType + ' +' + additionalCount);
            }
        }

        function setCategoryToggleText(text) {
            if (categoryToggle) {
                // Remove the arrow temporarily if it exists
                const arrow = categoryToggle.querySelector('.arrow');
                if (arrow) {
                    arrow.remove();
                }

                // Update text
                categoryToggle.textContent = text;

                // Add or remove 'selected' class based on whether a selection is active
                if (text !== 'Categorie') {
                    categoryToggle.classList.add('selected');
                } else {
                    categoryToggle.classList.remove('selected');
                }

                // Re-add the arrow
                categoryToggle.insertAdjacentHTML('beforeend', "<div class='arrow arrow--smallest arrow--down arrow--white ms-1'><span></span><span></span></div>");
            }
        }
    }
});
